<ng-template #productBodyTemplate>
  <h4
    class="text-2xl leading-7 self-stretch text-[--color-text-primary] my-1 px-4"
    [ngClass]="{
      'lg:text-5xl text-3xl font-extrabold': lightMode(),
      'lg:text-3xl text-1xl font-black': !lightMode(),
      'text-left font-bold': brand.isChmobile(),
      'text-center': !brand.isChmobile(),
    }"
  >
    {{ product().name }}
  </h4>

  <div class="flex flex-col justify-between flex-1">
    @if (!lightMode()) {
      @if (!product().prismicTable?.length) {
        <ngx-dynamic-hooks
          class="text-center flex-auto text-[--color-text-secondary] text-sm font-medium"
          [content]="product().short_description"
          [options]="{ sanitize: false }"
        >
        </ngx-dynamic-hooks>
      }
      <lib-product-features [product]="product()"></lib-product-features>
    }
  </div>
</ng-template>

@if (product()) {
  <lib-product-card [isOfferBox]="false" class="block pt-10 h-full" [cssClass]="cssClass()">
    <div
      class="product text-center h-full flex flex-col border border-solid border-[--color-gray-3] rounded-[--border-radius-product-boxes]"
      [ngClass]="{
        'shadow-[0_4px_4px_rgba(0,0,0,0.15)]': !lightMode(),
        'shadow-[0_1px_2px_0_rgba(231,231,231,0.7)]': lightMode(),
      }"
      data-testid="product-box"
    >
      <div class="h-12">
        @if (promotion() && hasDiscountedCost() && !lightMode()) {
          <lib-promotion-banner [countdownDate]="productItem().countdownDate" [text]="promotionBannerText()">
          </lib-promotion-banner>
        }
      </div>
      @if (!lightMode()) {
        <lib-link
          [attr.data-testid]="'product-' + product().product_code | lowercase"
          [link]="ctaLink()"
          [queryParams]="queryParams()"
          [queryParamsHandling]="'merge'"
          (onClick)="onProductBoxClick()"
          class="flex-auto flex flex-col [&>a]:flex-auto [&>a]:flex [&>a]:flex-col [&>a>span]:flex-auto"
        >
          <div class="flex flex-col h-full">
            <ng-container *ngTemplateOutlet="productBodyTemplate"></ng-container>
          </div>
        </lib-link>
      } @else {
        <ng-container *ngTemplateOutlet="productBodyTemplate"></ng-container>
      }
      <div class="flex justify-center mb-4">
        <lib-link
          class="w-full"
          [link]="ctaLink()"
          [queryParams]="queryParams()"
          [queryParamsHandling]="'merge'"
          (onClick)="onProductBoxClick()"
        >
          <div class="grid block my-4 gap-y-5">
            @if (!lightMode()) {
              <lib-product-card-chips [chipLabels]="chipsLabelsKeys()"></lib-product-card-chips>
            }
            @if (promotion() && hasDiscountedCost()) {
              <lib-product-card-price
                data-testid="product-price-discounted"
                [price]="product()?.monthly_cost.toString() | currencyFormatter"
                [discountedPrice]="discountedPrice().toString() | currencyFormatter"
                [discountLabel]="'- ' + discountPercentage() + ' %'"
              />
            } @else {
              <lib-product-card-price
                data-testid="product-price"
                [price]="product()?.monthly_cost.toString() | currencyFormatter"
              />
            }
          </div>
          <div class="px-5">
            <button class="button text-center w-full min-w-44 text-sm" [ngClass]="ctaStyling().classes">
              {{ ctaStyling().label }}
            </button>
          </div>
        </lib-link>
      </div>
      @if (!lightMode()) {
        <div class="mb-5 h-10 flex flex-col justify-between">
          @if (showLearnMore()) {
            <lib-link
              [attr.data-testid]="'product-detail-' + product().product_code | lowercase"
              [textCssClass]="'flex justify-center items-center text-[--color-text-primary] text-sm font-bold'"
              [link]="productDetailsLink()"
            >
              <lib-svg svg="fontawesome/list-check" class="normal mr-1"></lib-svg>
              {{ ['title', 'details'] | translate }}
            </lib-link>
          }
          @if (activationFee() !== 0) {
            <p class="text-[--color-text-secondary] text-xs">
              {{ activationFee() | currency: 'CHF' }} {{ ['activation_fee'] | translate }}
            </p>
          }
          @if (contractDuration() !== 0) {
            <p class="text-[--color-text-secondary] text-xs">
              {{ contractDuration() }} {{ ['contract_binding'] | translate }}
            </p>
          }
        </div>
      }
    </div>
  </lib-product-card>
}
